import React from "react";
import { truckIcon } from "assets/images"
import { CardLayout } from "components/cardLayout";
import "./toDoCard.scss"
//@ts-ignore
import SimpleLineIcon from 'react-simple-line-icons';
import { Popup } from "components/Popup"
import { AffirmTextLandingPage } from "components/affirmTextLandingPage"
declare var window: any;
export interface ToDoCardProps {
    
}
 
export interface ToDoCardState {
    open1?: boolean;
    Estimator:any;
}
 
class ToDoCard extends React.Component<ToDoCardProps, ToDoCardState> {
    constructor(props: ToDoCardProps) {
        super(props);
        this.state = {  
            open1: false,
            Estimator: localStorage.getItem("EstimatorDetails")
         };
    }
    handleOpen1 = () => {
        this.setState({ open1: true });
    };
    render() {
        window.affirm.ui.refresh();
        return ( 
            <CardLayout>
            <div className="todo-list">
            <div className="todo-detail">
                <div className="img-bg"><img src={truckIcon} alt="" /></div>
                <div><p>Sign Estimate</p></div>    
                </div>
                <div className="todo-detail"> 
                <div className="img-bg"><img src={truckIcon} alt="" /></div>
                <div><p>Sign Order of Service</p></div> 
                </div>
                <div className="todo-detail"> 
                <div className="img-bg"><img src={truckIcon} alt="" /></div>
                <div>
                    {
                        localStorage.getItem("isAffirm")==="1"?
                        <p>Move Now, Pay Later</p>
                        :<p>Pay Deposit</p>
                    }
                    </div> 
                 {localStorage.getItem("isAffirm")==="1"?   
                <div>
                    
                    <div className="icon-info affirm-site-modal"></div>

                        </div>
                        :<></>
                }
                </div>
        </div>
            </CardLayout>
         );
    }
}
 
export default ToDoCard;